export default __webpack_public_path__ + "images/dfe7a5c0dbb6b39b8c6eb9ebd9c46345-YGP_citybrowseheader_NYC_791x488px@2x.webp";